var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt009ColorDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bigdata_color_diamond",
    transform: "translate(-500 -296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    transform: "translate(500 344) rotate(-45)",
    fill: "#ecffe8",
    stroke: "#2edb0f",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 67.882,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 59.882,
    height: 59.882,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "big_data",
    transform: "translate(528.412 324.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M0,0H40V40H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(6.667 6.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M4,7.333a3.333,3.333,0,1,1,3.333,3.333A3.333,3.333,0,0,1,4,7.333ZM7.333,20.667A3.333,3.333,0,1,0,4,17.333a3.333,3.333,0,0,0,3.333,3.333Zm10-10A3.333,3.333,0,1,0,14,7.333a3.333,3.333,0,0,0,3.333,3.333Zm10,3.333a3.333,3.333,0,1,0,3.333,3.333A3.333,3.333,0,0,0,27.333,14ZM27.3,24a3.3,3.3,0,0,0-2.866,1.666H20.2a3.3,3.3,0,0,0-5.733,0H11.35l5.117-5.117a3.745,3.745,0,0,0,.867.117,3.343,3.343,0,0,0,3.333-3.333,3.488,3.488,0,0,0-.117-.85l5.933-5.933a3.488,3.488,0,0,0,.85.117A3.333,3.333,0,1,0,24,7.333a3.488,3.488,0,0,0,.117.85l-5.933,5.933a3.488,3.488,0,0,0-.85-.117A3.343,3.343,0,0,0,14,17.333a3.488,3.488,0,0,0,.117.85L8.183,24.117A3.488,3.488,0,0,0,7.333,24a3.333,3.333,0,1,0,0,6.667A3.3,3.3,0,0,0,10.2,29h4.284a3.3,3.3,0,0,0,5.733,0h4.25a3.28,3.28,0,0,0,2.867,1.667,3.343,3.343,0,0,0,3.333-3.333A3.393,3.393,0,0,0,27.3,24Z",
    transform: "translate(-4 -4)",
    fill: "#2edb0f"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt009ColorDiamond);
export default __webpack_public_path__ + "static/media/PT009_color_diamond.cd948eb2ec2119770a37d223afea6e9d.svg";
export { ForwardRef as ReactComponent };